import MUIDivider from "@mui/material/Divider";

const Divider = MUIDivider;

export default Divider;
